module.exports = [{
      plugin: require('/Users/damienclarke/projects/mosfez-site/packages/mosfez-site/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-prismjs","options":{"noInlineHighlight":true}}],"remarkPlugins":[[null,{"content":{"type":"text","value":""}}]],"rehypePlugins":[null]},
    }]
